import React, { createContext, PropsWithChildren, useEffect, useMemo, useState } from 'react';

import { get } from '@eika-infrastruktur/request';

import { useBankregnr } from '../config';
import { getRequestOptions } from '../meldskade/reducer/skademelding-actions';
import { AvtaleInfoWebDTO } from '../types/generated-types';
import { kundeHasAvtalerUrl } from '../urler';

export type AvtaleContext = {
    kundeHasOtherAvtaler: boolean;
    isPrivatAvtale: boolean;
    isEikaForsikring: boolean;
};

export const avtaleContext = createContext<AvtaleContext>({
    kundeHasOtherAvtaler: false,
    isPrivatAvtale: true,
    isEikaForsikring: false,
});

export const AvtaleProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const bankregnr = useBankregnr();
    const [avtaleInfo, setAvtaleInfo] = useState<AvtaleInfoWebDTO>();

    useEffect(() => {
        get(kundeHasAvtalerUrl(), getRequestOptions(bankregnr)).then((avtaleInfoWebDTO: AvtaleInfoWebDTO) =>
            setAvtaleInfo(avtaleInfoWebDTO),
        );
    }, [bankregnr]);

    const context: AvtaleContext = useMemo(
        () => ({
            kundeHasOtherAvtaler: avtaleInfo?.kundeHasOtherAvtaler || false,
            isPrivatAvtale: avtaleInfo?.privatAvtale || true,
            isEikaForsikring: bankregnr === '0502',
        }),
        [avtaleInfo, bankregnr],
    );

    const { Provider } = avtaleContext;

    return <Provider value={context}> {children} </Provider>;
};
